/**
 * Kiosk PWA - Self-Service Ordering Kiosk
 * Domain: kiosk.chain29.com
 * 
 * Touch-screen kiosk for customers:
 * - Browse menu
 * - Self-order
 * - Payment processing
 * - Loyalty integration
 * 
 * Phase 1A: Added StartOrderPage for order type selection
 */

import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';

// Theme
import './styles/kiosk-theme.css';

// Pages
import IdlePage from './pages/IdlePage';
import StartOrderPage from './pages/StartOrderPage';
import MenuPage from './pages/MenuPage';
import CartPage from './pages/CartPage';
import PaymentPage from './pages/PaymentPage';
import ConfirmationPage from './pages/ConfirmationPage';
import SetupPage from './pages/SetupPage';
import IdleGuard from './components/common/IdleGuard';
import { kioskPath } from './utils/kioskPath';

// Context providers
import { KioskProvider, useKiosk } from './context/KioskContext';

// Until this device is set up for a restaurant, only the setup screen is shown.
function KioskRoutes() {
  const { paired, activePayment } = useKiosk();
  const location = useLocation();
  if (!paired) return <SetupPage />;
  // A card try was open when this screen reloaded: back to it (the poll resumes; never a second charge).
  if (activePayment?.payment_id && !['declined', 'cancelled'].includes(activePayment.status)
      && !/\/payment\/?$/.test(location.pathname)) {
    return <Navigate to={kioskPath('payment')} replace />;
  }
  return (
    <>
    <IdleGuard />
    <Routes>
      <Route index element={<IdlePage />} />
      <Route path="start" element={<StartOrderPage />} />
      <Route path="menu" element={<MenuPage />} />
      <Route path="cart" element={<CartPage />} />
      <Route path="payment" element={<PaymentPage />} />
      <Route path="confirmation" element={<ConfirmationPage />} />
      <Route path="setup" element={<SetupPage />} />
      <Route path="*" element={<Navigate to={kioskPath('')} replace />} />
    </Routes>
    </>
  );
}

export default function KioskApp() {
  return (
    <KioskProvider>
      <Toaster 
        position="top-center" 
        richColors 
        toastOptions={{
          style: {
            background: '#1a1f26',
            border: '1px solid rgba(255,255,255,0.1)',
            color: '#fff',
          },
        }}
      />
      <KioskRoutes />
    </KioskProvider>
  );
}
